export default {
  STORE_ROOT: 'STORE_ROOT',
  STORE_CONFIG: 'STORE_CONFIG',
  STORE_ROUTER: 'STORE_ROUTER',
  STORE_PREVIEW: 'STORE_PREVIEW',
  STORE_APOLLO: 'STORE_APOLLO',
};
